/**
 * Actions 统一导出入口
 *
 * 这个文件作为所有 server actions 的统一导出入口，
 * 便于管理和使用各种操作函数。
 */

// Contact Us 相关操作
export {
    createContactUs,
    type ContactUsFormValues,
    type ContactUsState,
} from './contact-us';

// 邮件订阅相关操作
export {
    createEmailSubscribe,
    type EmailSubscribeState,
} from './email-subscribe';

// Invoice 相关操作
export {
    createInvoice,
    updateInvoice,
    deleteInvoice,
    type InvoiceState,
} from './invoice';

// 认证相关操作
// export { authenticate } from './auth';

// 为了向后兼容，保留原来的 State 类型别名
export type { InvoiceState as State } from './invoice';
